import { render, staticRenderFns } from "./ProfileBlock.vue?vue&type=template&id=91d0f9b6&scoped=true&"
import script from "./ProfileBlock.vue?vue&type=script&lang=js&"
export * from "./ProfileBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBlock.vue?vue&type=style&index=0&id=91d0f9b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d0f9b6",
  null
  
)

export default component.exports